import AppStore from '@v4/store/appStore'
import useStyles from './Image.styled'

export const useImage = props => {
	const { className, metaData, onClick, children, isBackground = false } = props
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const { classes, cx } = useStyles({ ...props, isBackground })

	return [
		{
			className,
			classes,
			cx,
			src: metaData?.imageThumb,
			alt: metaData?.alt,
			srcSet: metaData?.imageSrcSet,
			timeout: isBuilderMode ? 300 : 0,
			isBackground,
			isServer: import.meta.env.SSR,
			children,
		},
		{
			handleClick: onClick,
		},
	]
}
